import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class PasswordsService {
  constructor(private api: ApiService) {}

  change(userId: string, currentPassword: string, newPassword: string) {
    return this.api.post<void>(`/api/users/${userId}/password/change`, { currentPassword, newPassword });
  }

  isExpired(userId: string) {
    return this.api.get<{ expired: boolean }>(`/api/users/${userId}/password/expired`);
  }
}
